import { motion } from 'framer-motion';
import styled from 'styled-components';

import { fadeTransition, FadeVariant, fadeVariants } from '@pkg/motion';
import { styledMedia } from '@pkg/primitives';

import { overlayBase, tokens } from '../../tokens';

export const StyledFallback = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})`
    ${overlayBase};
    background: ${tokens.fallback.gradient};
`;

export const Image = styled.img`
    // Required to combat v2-global-reset
    && {
        ${styledMedia.mediaCover};
        max-width: 50%;
        object-fit: contain;
    }
`;
